// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"f439df95","326":"b2aba6ac","412":"9eca9c29","785":"04c6508c","787":"cda612ba"}[chunkId] + ".chunk.js";
};